import ability from '@/plugins/acl/ability'

type Actions = 'read' | 'manage'
type Subjects = 'read_all_periods' | 'read_receipt_sequence_numbers'

interface AbilityOptions {
  action: Actions
  subject: Subjects
}

export interface AbilityEvaluateResult {
  can: boolean
}

export function useAbilityEvaluate() {
  const evaluateAbility = (options: AbilityOptions): AbilityEvaluateResult => {
    const {
      action,
      subject,
    } = options

    // 基本的なabilityチェック
    const canByAbility = ability.can(action, subject as any)

    return {
      can: canByAbility,
    }
  }

  const canAccessPeriod = () => {
    return evaluateAbility({
      action: 'read',
      subject: 'read_all_periods',
    }).can
  }

  const canAccessReceiptSequenceNumbers = () => {
    return evaluateAbility({
      action: 'read',
      subject: 'read_receipt_sequence_numbers',
    }).can
  }

  return {
    evaluateAbility,
    canAccessPeriod,
    canAccessReceiptSequenceNumbers,
  }
}
